import React from 'react'
import moment from 'moment'

import { useUserPreference } from '../../user/hooks'
import { PREFERENCES } from '../../user/constants'

moment.relativeTimeRounding(Math.floor)

const IncidentDate = ({ style, date, children }) => {
  const timestampFormat = useUserPreference(PREFERENCES.TIMESTAMP_FORMAT)

  const formattedDate =
    timestampFormat === 'relative'
      ? moment(moment.utc(date).format('YYYY-MM-DD HH:mm:ss.SSSSSSSSS')).fromNow()
      : moment.utc(date).format('M/D/YYYY h:mmA')

  return (
    <div className={style}>
      {children} {formattedDate}
    </div>
  )
}

export default IncidentDate
